import DistrictCalendar from "@/components/DistrictCalendar";

export default function CorporateCalendarPage() {
  return (
    <main className="px-6 md:px-10 py-8" data-testid="corporate-calendar-page">
      <DistrictCalendar />
    </main>
  );
}
